import React, { useEffect, useState } from 'react';
import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import { useDispatch, useSelector } from "react-redux";
import { JobListing } from "./helpers/JobListing";
import * as actions from "../../actions/InstallationActions";
import { CollapsibleSection } from "./helpers/CollapsibleSection";
import { JobFilterForm } from "./helpers/JobFilterForm";
import { SortAndFilterButtons } from "./helpers/SortAndFilterButtons";

export default function InstallationCompleted() {

    const dispatch = useDispatch()
    const sort = useSelector(state => state.sort)
    const filter = useSelector(state => state.filter)
    const jobList = useSelector(state => state.jobListCompleted)
    const [loading, setLoading] = useState(true);
    const [showFilterForm, setShowFilterForm] = useState(false);

    const handleFilterToggle = () => {
        setShowFilterForm(!showFilterForm);
    };

    useEffect(() => {
        dispatch(actions.JobListCompleted());
        dispatch(actions.SortNew('completed'));
        setLoading(false);
    }, [dispatch]);
    
    return (
        <div>
            <AuthenticatedTemplate>
             
                <SortAndFilterButtons sort={sort} filter={filter} listType="completed" handleFilterToggle={handleFilterToggle} />
                
                <div className="page-container page-container--small-gap">
                    {showFilterForm && (
                        <CollapsibleSection 
                            header="Filter Completed Jobs" 
                            content={<JobFilterForm listType={"completed"} showInstallerName={true} cursort={sort}/>} 
                            isOpenByDefault={true}
                        />
                    )}

                    <div className="page-section">

                        {loading ? "loading job list ...." :
                            jobList.length > 0 ?
                                jobList.map(job => <JobListing job={job} key={job.ID}/>)
                                :
                                <p>There were no results matching those parameters!</p>
                        }

                    </div>
                    
                </div>
                
            </AuthenticatedTemplate>
            <UnauthenticatedTemplate>
                <p>You are trying to view the completed installation jobs page while signed out. Please sign in to
                    continue.</p>
            </UnauthenticatedTemplate>
        </div>
    );
}
